const deleteProduct = (NOMBRE)=> {
    var old = JSON.parse(localStorage.getItem("carrito"))
    var i = 0;
    for (; i < old.length ;){
        if (old[i].cant === 0){
            old.splice(i, 1)
        }
        i++
    }
    localStorage.setItem("carrito", JSON.stringify(old))
}

export { deleteProduct }